import { $$ } from 'utils/dom';
import Lightbox from 'modules/Lightbox/Lightbox';

const imageWrappers = $$('.image, .textmedia');
if (imageWrappers.length) {
  imageWrappers.forEach(image => {
    new Lightbox(image, {
      selector: '.lightbox-toggle',
    }).init();
  });
}
